import "../Model/Cell";
export class BoardsService {
    constructor(httpService, boardsFactory) {
        this.httpService = httpService;
        this.boardsFactory = boardsFactory;
    }
    async getBoardByGameAndPlayer(roomId, gameId, playerId) {
        const response = await this.httpService.get(`board/${roomId}/${gameId}/${playerId}`);
        if (response.status === 404) {
            return null;
        }
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el cartón de juego.');
        }
        return this.boardsFactory.createBoardFromDto(await response.json());
    }
    async getBoardsOfCurrentGameInRoom(roomId) {
        const response = await this.httpService.get(`room/${roomId}/boards`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener los cartones del juego actual en la sala');
        }
        const content = await response.json();
        return content.map((dto) => this.boardsFactory.createBoardFromDto(dto));
    }
}
